import i18next from '@/translation/i18n';

export enum ReportType {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
    ANNUAL = 'ANNUAL',
    CUSTOM = 'CUSTOM',
}

export const ReportTypeLabel: Record<ReportType, string> = {
    [ReportType.DAILY]: i18next.t('report:type.daily'),
    [ReportType.WEEKLY]: i18next.t('report:type.weekly'),
    [ReportType.MONTHLY]: i18next.t('report:type.monthly'),
    [ReportType.QUARTERLY]: i18next.t('report:type.quarterly'),
    [ReportType.ANNUAL]: i18next.t('report:type.annual'),
    [ReportType.CUSTOM]: i18next.t('report:type.custom'),
};
